/** @description 合同-合同信息字段 **/
import { formatPics, filterParams, formatDelivery } from '@/common/utils/format'
import { get } from 'lodash-es'
import { i18n, getBDCountry } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

// 从后端去取哪些字段显示在当前页面上
const PARAMS_KEYS_LIST = [
  'deliveryType',
  'contractType',
  'contractVersion',
  'contractNo',
  'partyaName',
  'partyaAddr',
  'partyaCompanyId',
  'partyaEmail',
  'partyaContact',
  'partyaTitleType',
  'partyaTitleText',
  'partyaPhone',
  'platformType',
  'platformRate',
  'deliveryMinRate',
  'oneselfType',
  'oneselfRate',
  'contractorType',
  'contractPic',
  'commissionSubsidyRatio',
  'commissionSubsidyDays',
  'commissionAuditPics',
  'commissionJson',
  'signType',
  'partyaIdno',
  'partyaPics'
]

// 后端下发的字段进行格式化
export function revert (data = {}) {
  const contractData = get(data, 'contractGlobal')
  let revertted = {}
  revertted = {...filterParams(PARAMS_KEYS_LIST, contractData)}
  revertted.contractPic = formatPics(contractData.contractPic)
  revertted.partyaPics = formatPics(contractData.partyaPics)
  revertted.commissionAuditPics = formatPics(contractData.commissionAuditPics)
  revertted.deliveryMinRate = (revertted.deliveryMinRate || 0) / 100
  revertted.contractType = revertted.contractType === 0 ? null : revertted.contractType
  revertted.partyaTitleType = revertted.partyaTitleType === 0 ? null : revertted.partyaTitleType
  revertted.contractorType = revertted.contractorType === 0 ? null : revertted.contractorType
  return formatDelivery(revertted)
}

export function submitFormat (contractGlobal) {
    // 根据合同类型过滤字段(“佣金策略合同模板”选择下”佣金补贴比例“和“佣金补贴周期”、“佣金审核证明”)
    const { contractType } = contractGlobal
    if (contractGlobal && contractType !== 2) {
      contractGlobal.commissionSubsidyDays && (contractGlobal.commissionSubsidyDays = 0)
      contractGlobal.commissionSubsidyRatio && (contractGlobal.commissionSubsidyRatio = 0)
      contractGlobal.commissionAuditPics && (contractGlobal.commissionAuditPics = '')
      contractGlobal.commissionSubsidyTimes && (contractGlobal.commissionSubsidyTimes = '')
    }
    if (!contractGlobal.deliveryType) {
      throw new Error(i18n.gettext('平台配送及自配送不允许同时选择不支持'))
    }
    return {
      params: JSON.stringify({
        source: 'contractor',
        queryId: this.$route.params.id,
        contractGlobal
      })
    }
  }

export default {
  revert,
  submitFormat
}
